import React, { FunctionComponent } from 'react';
import Icon from '../../@shared/icon';

interface IHeroCarouselArrowProps {
  direction: 'previous' | 'next';
  onClick: () => void;
}

const HeroCarouselArrow: FunctionComponent<IHeroCarouselArrowProps> = ({ direction, onClick }) => {
  const icon = 'arrow-chevron-' + (direction === 'previous' ? 'left' : 'right');
  return (
    <button className={'controls__arrow controls__arrow--' + direction} aria-label={direction + 'slide / item'} onClick={onClick}>
      <Icon iconName={icon as 'arrow-chevron-left' | 'arrow-chevron-right'} size={32} color="white" />
    </button>
  );
};

export default HeroCarouselArrow;
